<template>
  <div class="big-box">
    <div class="box-research">
      <slot name="box-img">
        <img v-complete:src="info.image" alt="" />
      </slot>
      <slot name="boxContent">
        <div class="box-title">
          <slot name="title">
            <p class="title-p" @click="submitButton(info.id)">
              {{ info.title }}
              <!-- 考试改革和课程标准的要求《国家中长期教育改革和发展规划纲要(20xx—20xx年)》在"考试发展规划纲要(20xx—20xx年)》在"考试中111111111111111111 -->
            </p>
          </slot>
          <slot name="details">
            <div class="icon-box">
              <el-icon><Calendar /></el-icon>
              <p>
                上传时间：
                <span>
                   {{ dayjs(info.release_time * 1000).format("YYYY-MM-DD") }}
                  <!-- {{ dayjs(info.start_time * 1000).format("YYYY-MM-DD") }}~{{
                    dayjs(info.end_time * 1000).format("YYYY-MM-DD")
                  }} -->
                </span>
              </p>
            </div>
            <div class="icon-box">
              <!-- <el-icon><User /></el-icon> -->
              <el-icon><Position /></el-icon>
              <p>
                文章来源：
                <span>
                  {{ info.source }}

                </span>
              </p>
            </div>
            <div class="icon-box2" @click="submitButton(info.id)">
              <div>
                <el-icon><Document /></el-icon>
                <p>内容摘要：</p>
              </div>
              <p>
                {{ info.intro }}
                <!-- 考试改革和课程标准的要求《国家中长期教育改革和发展规划纲要(20xx—20xx年)》在"考试发展规划纲要(20xx—20xx年)》在"考试中考试改革和课程标准的要求《国家中长期教育改革和发展规划纲要(20xx—20xx年)》在"考试发展规划纲要(20xx—20xx年)》在"考试中 -->
              </p>
            </div>
          </slot>

          <slot name="collect"></slot>
          <!-- <el-button type="primary" @click="submitButton(info.id)"
            >查看详情</el-button
          > -->
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { User,Position,Document } from "@element-plus/icons-vue";
import { reactive } from "vue";

import { useRouter } from "vue-router";

import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
// .big-box {
//   // background-color: red !important;
//   width: 1200px;
//   height: 288px;
//   margin: 0 auto;
//   //  border-top:1px solid #CCCCCC;
//   // border: 1px solid rgb(21, 255, 0);
//   background-color: #ffffff;
//   box-shadow: 0px 5px 40px 0px #0000000D;
//   padding: 30px;
//   border-radius: 8px;
// }
.box-research {
  width: 343px;
  // height: 414px;
  margin: 0 auto;
  //  border-top:1px solid #CCCCCC;
  // border: 1px solid rgb(21, 255, 0);
  background-color: #ffffff;
  padding: 16px;
  border-radius: 8px;
  > img {
    width: 311px;
    height: 201px;
    // margin-right: 24px;
    border-radius: 8px;
    display: block;


    // cursor: pointer;
  }

  > .box-title {
    // position: relative;
    // width: 718px;
    margin-top:10px;
    .title-p {
      // width:100%;
      width: 100%;
      min-height: 24px;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;

      font-size: 16px;
      font-weight: 700;
      color: #333333;

      cursor: pointer;
    }

    .title-p:hover{
      color:#009de0;
    }
    .icon-box {
      width: 100%;
      // height: 22px;
      line-height: 22px;

      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;

      // border: 1px solid red;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 8px;
      p {
        margin-left: 8px;
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //文本溢出 用省略号显示
        overflow: hidden;
      }
    }
    .icon-box:nth-of-type(1) {
      margin-top: 12px;
    }

    .icon-box2 {
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      
      cursor: pointer;
      > div {
        display: flex;
        :deep(.el-icon) {
          margin-right: 8px;
          margin-top:2px;
        }
        p {
          // border:1px solid red;
          width: 70px;
          margin-right: 4px;
        }
      }
      > p {
        margin-top:-1px;
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
    }
    .icon-box2:hover{
      color:#009de0;
    }
    :deep(.el-button.el-button--primary) {
      width: 134px;
      height: 35px;
      padding: 10px;
      border-radius: 30px;
      position: absolute;
      right: 0px;
      bottom: 0px;
      > span {
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
    }

    > .p1-research {
      color: #666666;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 16px;
      color: #666666;
    }
    > .p2-research {
      color: #333333;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 12px;
    }
    > .p3-research {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 18px;
    }
  }
}
</style>